export default __webpack_public_path__ + "static/summer_containers34-613059b7d90ece7cb3ab1d6bdf5b011a.webp";